<template>
  <div class="calendar">
    <div class="top-poster" :style="`min-height:${minHeight}px;`">
      <!-- <img class="banner" :src="bannarUrl" ref="bannerBack"/> -->
         <div class="virtuallydom">
            <img v-if="isActivityEnd" class="endimg" src="../../../assets/pointsActivity/end-img.png">
            <div class="top-box">
              <div class="activity" v-if="desc" @click="openModal">
                <img src="../../../assets/pointsActivity/detailicon.png" />
                活动说明
              </div>
            </div>
            <van-swipe :autoplay="3000" lazy-render class="swipe">
              <van-swipe-item v-for="image in images" :key="image">
                <img :src="image" class="image" />
              </van-swipe-item>
          </van-swipe>
          </div>
    </div>
    <van-popup v-model="popupVisible" position="bottom">
      <div class="popup-content">
        <div class="popup-tit">
          活动说明
          <van-icon name="cross" @click="hidePopup"/>
        </div>
        <div class="popup-text">
          <p>{{ allInfo.prizeCurrent?.desc }}</p>
        </div>
        <div class="popup-btn" @click="hidePopup">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Image as VanImage, Lazyload } from 'vant';
export default {
  name: "calendar",
  props: {
    desc: {
      type: String,
    },
    bannarUrl: {
      type: String,
      default: '',
    },
    allInfo: {
      type: Object,
    },
    calendarData:{
      type:Array,
      default:[]
    },
    isActivityEnd:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    calendarData(val){

      if(val.length <= 0){
        return false
      }
      let currentDay = new Date().toLocaleDateString('zh', {
        year: 'numeric', month: '2-digit',
        day: '2-digit'
      })
      let startDay = new Date(val[0].orderTime.replaceAll("-","/")).getDay()
        this.dayList = new Array((startDay)%7).fill(null).concat(val.map(day=>{
        if(!day){
          return null;
        }
        let currentTimeStamp = new Date(currentDay.replaceAll("-","/")+" 00:00:00").getTime()
        let itemDate = new Date(day.orderTime.split(" ")[0].replaceAll("-","/")+" 00:00:00")
        let itemTimeStamp = itemDate.getTime()
        return {
          day:itemDate.getDate(),
          month: itemDate.getMonth() + 1,
          points:day.points,
          isBefore:itemTimeStamp < currentTimeStamp,
          isCurrent:itemTimeStamp == currentTimeStamp
        }
      }))
      this.daysList = []
        const dayArr = []
        const firstList = []
        if (this.dayList.length >= 31) {
          let count = 0
          this.dayList.forEach((item, index) => {
            if (count < 31) {
              if (item !== null) {
                count ++
              }
              firstList.push(item)
            }
          })
          if (firstList.length % 7 == 0) {
            this.line = Math.floor(firstList.length/7)
          } else {
            this.line = Math.floor(firstList.length/7) + 1
          }
       }
        this.dayList.forEach((item,index) => {
          if(index % (this.line * 7) === 0) {
          dayArr.push([]);
          }
          dayArr[dayArr.length - 1].push(item);
        })
        dayArr.forEach((item, index) => {
          item.forEach((day, dayIndex) => {
            if (day?.isCurrent) {
              this.currentIndex = index
            }
          })
          this.daysList.push({
            startMonth: item.filter(item => item !== null)[0].month,
            lastMonth: item[item.length - 1].month,
            startDay: item.filter(item => item !== null)[0].day,
            lastDay: item[item.length - 1].day,
            days: item,
            index: 0
          })
        })
        this.daysList.forEach ((item,index)=>{
          item.days.forEach((day, dayIndex) => {
            if (day !== null) {
              item.index ++
            }
          })
        })
        if (this.daysList.length == 2 && this.daysList[0].index + this.daysList[1].index <= 31) {
          let a = this.daysList[0].days.concat(this.daysList[1].days)
          let list = this.daysList
          this.daysList = []
          this.daysList.push({
            startMonth: list[0].month,
            startDay: list[0].day,
            lastMonth: list[1].lastMonth,
            lastDay: list[1].lastDay,
            days: a,
            index: 0
          })
        }
    },
    bannarUrl(val){
      if(val != ''){
        this.getImgHeight();
      } 
    },
  },
  data() {
    return {
      startTime: undefined,
      popupVisible: false,
      currentMonth: "",
      daysOfWeek: ['日','一','二','三','四','五','六',],
      dayList:[],
      monthList:[],
      touchAble: true,
      daysList: [],
      minHeight:0,
      isLeftTouch: false,
      isRightTouch: false,
      i: 0,
      startX: null,
      line: 5,
      currentIndex: 0 //当前页面
    }
  },
  methods: {
    onTouchMove (e) {
      e = e || event
      e.preventDefault()
      let surrentStartX 
      if(e.touches.length == 1 ) {
        surrentStartX = e.touches[0].clientX
      }
      if(surrentStartX < this.startX ) {
        // 右滑
        if (this.currentIndex >= this.daysList.length - 1) {
          this.touchAble = false
        } else {
          this.touchAble = true
        }
        this.$refs.swipe.resize()
      } else {
        // 左滑
        if (this.currentIndex <= 0) {
          this.touchAble = false
        } else {
          this.touchAble = true
        }
        this.$refs.swipe.resize()
      }
    },
    listChange(index){
      this.currentIndex = index
      // index即为改变后的页面索引，可写需要操作
    },
    // 记录初始滑动位置
    onTouchStart (e) {
      this.touchAble = true
      e = e || event
      e.preventDefault()
      if(e.touches.length == 1 ) {
        this.startX = e.touches[0].clientX
      }
    },
    getImgHeight(){
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.minHeight = this.$refs.bannerBack.height
          console.log('minHeight',this.minHeight)
          if(this.minHeight == 0){
            this.getImgHeight();
          }
        },0)
      })
    },
    openModal() {
        //点击-攒星值活动-活动说明
      this.popupVisible = true
      this.$emit("openModal","mkt_points_page_declare_click")
    },
    hidePopup() {
      this.popupVisible = false
    },
    startButton (val) {
      if(val==='right'){
        this.isRightTouch = true
        this.isLeftTouch = false
      } else {
        this.isLeftTouch = true
        this.isRightTouch = false
      }
    },
    clearLoop (val) {
      this.isRightTouch = false
      this.isLeftTouch = false
    },
    
    // 点击左右箭头
    clickIcon(val) {
      if (val === 'down') {
        if (this.currentIndex < this.daysList.length - 1) {
          this.$refs.swipe.next()
        }
      } else {
        if (this.currentIndex > 0) {
          this.$refs.swipe.prev()
        }
      }
    },
  },

}
</script>

<style lang="scss" scoped>
@import "~@/font/D-DIN-PRO/dDinPro500.css";

.calendar{
  width: 100%;
  background: #ffffff;

  .top-poster {
    position: relative;
    width: 100%;
    display: flex;
    align-items: flex-end;

    .banner {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }
    
    /* 箭头图标 */
    .iconDiv{
      position: absolute;
      top: calc(65% - 40px);
      transform: translateY(-50%);
      line-height: 30px;
      text-align: center;
      font-size: 25px;
      cursor: pointer;
      width: 28px;
      height: 96px;
      background-color: #000000;
      border-radius: 14px;
      opacity: 0.25;
      z-index: 999;
      .icon {
        width: 28px;
        height: 96px;
      }
    }
    .iconDiv:active {
      background-color: white;
    }
    .icon-left{
      left: 14px;
    }
    .icon-right{
      right: 12px;
    }

    .virtuallydom {
      padding: 0px 50px 72px 52px;
      width: calc(100% - 100px);
      position: relative;

      .endimg {
        width: 144px;
        height: 144px;
        position: absolute;
        top: 26px;
        left: 210px;
        z-index: 100;
      }

    .top-box {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 26px 0 24px 0;
        justify-content: space-between;
        margin-left:  -20px;

        .month {
          display: flex;
          align-items: center;
          font-size: 28px;
          color: #3A3B3C;
          font-weight: 500;
          z-index: 1;
          padding-top: 4px;

          div {
            display: flex;
            align-items: baseline;
          }

          .line{
            font-weight: normal;
            font-size: 50px;
            font-family: "D-DIN-PRO-500-Medium";
          }

          .tail{
            position: relative;
            .month-text {
              font-size: 40px;
              color: #3A3B3C;
              font-weight: 500;
              margin: 0 10px;
              font-family: "D-DIN-PRO-500-Medium";
              padding-right: 0px;
              height: 40px;
              line-height: 40px;
            }
            .month-unit{
              font-size: 24px;
              color: #5E5E5E;
              font-family: PingFangSC-Medium, PingFang SC;
              bottom: 12px;
              font-weight: 500;
              height: 24px;
              line-height: 24px;
            }
          }
        }


        .activity {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 48px;
          width: 148px;
          line-height: 48px;
          text-align: center;
          background: rgba(58, 59, 60, 0.3);
          border-radius: 28px;
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
          z-index: 1;
          font-family: PingFangSC-Medium, PingFang SC;
          float: right;
          margin-right: -30px;

          img{
            width: 26px;
            height: 26px;
            margin: 0 4px;
          }
        }
      }

      .week {
        width: 100%;
        display: flex;
        justify-content: space-between;
        // margin-bottom:x;

        .week-item {
          width: 74px;
          height: 40px;
          line-height: 40px;
          font-size: 24px;
          color: #3C3C3C;
          text-align: center;
          font-weight: 600;
          z-index: 1;
        }
      }

      .my-swipe {
        padding: 22px 0px 0px 50px;
        width: calc(100% + 100px);
        margin-left: -50px;
        .line-five {
          height: 440px;
        }
        .line-six {
          height: 528px
        }
        
        .date {
        width: 100%;
        display: Grid;
        //justify-content: space-between;
        grid-template-columns: repeat(7, 72px);
        grid-gap: 0 24px;
        //grid-template-rows: repeat(1, 72px);

        .date-item {
          width: 72px;
          height: 72px;
          position: relative;
          font-weight: 400;
          text-align: center;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 0.36rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0;
          color: #3C3C3C;
          margin-bottom: 16px;
          position: relative;

          .opacityBox{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.4);
            position: absolute;
            color:#979797;
            left: 0;
            top: 0;
            z-index: 1;
          }

          .points-txt{
            position: absolute;
            width: 32px;
            height: 30px;
            top: 1px;
            transform:translate(-50%,-50%);
            left: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 32px;
              height: 30px;
              position: absolute;
              left: 0;
              top: 0;
              z-index: -1;
            }
            span {
              color: #ffffff;
              font-size: 18px;
              zoom: .65;
              margin-top: 3px;
            }
          }

        }

        .activeColor {
          width: 68px !important;
          height: 68px !important;
          color: #A52337 !important;
          border: 2px solid #FF7E7E;
          background: #ffffff;
        }

        .activeBackground {
          color: #fff !important;
          background: #A52337 !important;
        }

      }
      

      .tip {
        margin: 24px auto;
        width: 280px;
        line-height: 56px;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 28px;

        span {
          color: #A52337;
        }

        img {
          vertical-align: sub;
          width: 32px;
          height: 32px;
        }
      }
    }
      }
  }

  .van-popup--bottom {
    border-radius: 16px 16px 0 0;

    .popup-content {
      width: 100%;
      height: 100%;

      .popup-tit {
        position: relative;
        text-align: center;
        line-height: 96px;
        height: 96px;
        color: #3A3B3C;
        font-size: 32px;
        font-weight: bold;
      }

      .van-icon-cross {
        position: absolute;
        right: 20px;
        top: 25px;
        font-size: 36px;
      }

      .popup-text {
        //width: calc(100% - 96px);
        padding: 0 48px;
        line-height: 40px;
        margin: auto;
        max-height: 500px;
        overflow: auto;

        p {
          margin-top: 16px;
          font-size: 26px;
          white-space: pre-wrap;
          color: #3A3B3C;
        }
      }

      .popup-btn {
        width: calc(100% - 96px);
        margin: 0 auto;
        margin-top: 16px;
        margin-bottom: 64px;
        line-height: 96px;
        background: #A52337;
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
      }
    }
  }
}
</style>
